import { useFetchVenues } from "../../../redux/flows/fetchVenuesFlow";
import BookingFlowShell from "../common/components/BookingFlowShell/BookingFlowShell";
import ApartmentOverview from "./ApartmentOverview";
import ApartmentSelectionStep from "./ApartmentSelectionStep";
import BookingOverview from "./BookingOverview";
import LocationAndDurationSelectionStep from "./LocationAndDurationSelectionStep";
import PersonalData from "./PersonalDataStep";
import BookingSuccess from "./BookingSuccess";
import Payment from "../roomRental/Payment";
import { BookingCreationStep } from "../common/bookingCreationStep";
import { useMemo } from "react";
import { useEventFlowUseCase } from "./eventFlowUseCase";
import { configFor } from "./eventFlowConfig";

// Re-exported for the flow's existing importers.
export { BookingCreationStep };

interface BookLocationDialogProps {
  returnPage: string;
}

/** The venue booking flow on the shared shell, for the use case its dialog
 *  states (venue, or a sports hall) — configuration in `eventFlowConfig.ts`. */
const BookLocationPage = (props: BookLocationDialogProps) => {
  const useCase = useEventFlowUseCase();
  const fetchVenues = useFetchVenues(useCase);
  const config = useMemo(() => configFor(useCase), [useCase]);

  return (
    <BookingFlowShell
      config={config}
      fetchObjects={fetchVenues}
      steps={{
        locationSelection: <LocationAndDurationSelectionStep />,
        objectSelection: <ApartmentSelectionStep />,
        objectOverview: <ApartmentOverview />,
        bookingSummary: <BookingOverview />,
        personalData: <PersonalData />,
        payment: <Payment service={useCase} />,
        success: <BookingSuccess />,
      }}
    />
  );
};

export default BookLocationPage;
